import { Preferences } from './WebPreferences';

export const REMOVE_ADS_SKU = '';
export const PREMIUM_SUB_SKU = '';

export async function getAdsRemoved() {
  return true; // No ads on web
}
export async function setAdsRemoved(val) {
  await Preferences.set({ key: 'adsRemoved', value: val ? 'true' : 'false' });
}
export async function initIAP() {}
export async function getProductPrice() { return null; }
export async function getLifetimePrice() { return null; }
export async function purchaseRemoveAds(onSuccess, onFailed) { onSuccess(); }
export async function purchaseLifetime(onSuccess, onFailed) { onSuccess(); }
export async function restorePurchases() { return false; }
